import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import { FirmSignPage } from "./pages/FirmSignPage";
import { PrepareSignaturePage } from "./pages/PrepareSignaturePage";

/** /signatures/new (prepare and send) and /signatures/:id/sign (countersign). */
export const SignaturesView = () => (
  <Routes>
    <Route path={"new"} element={<PrepareSignaturePage />} />
    <Route path={":id/sign"} element={<FirmSignPage />} />
    <Route path={"*"} element={<Navigate to={"/home"} replace={true} />} />
  </Routes>
);
